<template>
  <div class="app loginPageContainer">
    <div class="container-fluid">
      <LanguageSelect />
      <b-row class="hero-login-section d-flex align-items-center">
        <b-col md="7" class="left-img md:tw-block tw-hidden fullBgImg">
          <div class="login-page-slider">
            <div class="slider-container">
              <div
                v-for="(slide, index) in slides"
                :key="index"
                :class="['slide-wrapper', { active: currentSlide === index }]"
              >
                <div
                  class="slideImgContainer"
                  style="padding-bottom: 0px !important"
                >
                  <img
                    :src="slide.image"
                    class="img-fluid slide-image"
                    :alt="slide.title"
                  />
                </div>
                <div class="slide-content">
                  <h2>
                    {{ translatedLang[slide.title][selectedLanguage.key] }}
                  </h2>
                  <p>
                    {{
                      translatedLang[slide.description][selectedLanguage.key]
                    }}
                  </p>
                </div>
              </div>
              <div class="slider-controls">
                <div class="slider-dots">
                  <span
                    v-for="(slide, index) in slides"
                    :key="index"
                    :class="['dot', { active: currentSlide === index }]"
                    @click="goToSlide(index)"
                  >
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="brand-slider">
            <swiper :options="swiperOptions">
              <swiper-slide
                v-for="slide in sliderImages"
                :key="slide.id"
                class="brand-slide"
              >
                <img
                  :src="slide.image"
                  :alt="slide.altDec"
                  class="brand-logo"
                />
              </swiper-slide>
            </swiper>
          </div>
        </b-col>
        <b-col
          md="5"
          class="right-form flex-column justify-content-center align-items-start"
        >
          <div class="weavrLogoContainer">
            <div style="height: 40px">
              <img
                src="Icons_SVG/weavr-login-img.svg"
                height="100%"
                alt="Brand Logo Full"
              />
            </div>
          </div>

          <b-form @submit.prevent="login" class="login-form">
            <div class="login-heading">
              <h2
                class="mb-0 mt-4 tw-text-[#000000] tw-font-[600] tw-leading-[36px] tw-text-[28px]"
              >
                {{ translatedLang["Sign in"][selectedLanguage.key] }}
              </h2>
              <p class="subHeading mb-0">
                {{
                  translatedLang[
                    "Enter your credentials to access Weavr Account"
                  ][selectedLanguage.key]
                }}
              </p>
            </div>
            <b-input-group class="input-group">
              <label
                @input="flagError = false"
                :class="{ danger: flagError, usernameinput: !flagError }"
                >{{ translatedLang["Email"][selectedLanguage.key] }}</label
              >
              <div class="position-relative input-with-icon">
                <div class="position-absolute inputIconContainer">
                  <img
                    src="Icons_SVG/emailWeavr.svg"
                    height="100%"
                    alt="email icon"
                  />
                </div>
                <input
                  type="text"
                  v-model="username"
                  placeholder="Enter your email address"
                  autocomplete="username email"
                  @input="flagError = false"
                  :class="{ danger: flagError, usernameinput: !flagError }"
                />
              </div>
            </b-input-group>
            <b-input-group class="input-group">
              <label
                @input="flagError = false"
                :class="{ danger: flagError, usernameinput: !flagError }"
                >{{ translatedLang["Password"][selectedLanguage.key] }}</label
              >
              <div class="position-relative input-with-icon">
                <div class="position-absolute inputIconContainer">
                  <img
                    src="Icons_SVG/passwordWeavr.svg"
                    height="100%"
                    alt="password icon"
                  />
                </div>
                <input
                  :type="showPassword ? 'text' : 'password'"
                  v-model="password"
                  placeholder="Enter your Password"
                  autocomplete="current-password"
                  @input="flagError = false"
                  :class="{ danger: flagError, passwordinput: !flagError }"
                />
                <button
                  type="button"
                  class="password-toggle-btn position-absolute"
                  @click="showPassword = !showPassword"
                >
                  <i
                    :class="showPassword ? 'fa fa-eye-slash' : 'fa fa-eye'"
                  ></i>
                </button>
              </div>
              <div
                v-if="flagError"
                style="color: var(--red); font-size: 0.8rem"
                class="mb-2 flagError"
              >
                &#9888; Email or the password is incorrect, please try again.
              </div>
            </b-input-group>
            <div class="remember-forgot-section">
    <div>
    <!-- <input type="checkbox" id="remember-me" name="remember-password" value="{{}}" />
    <label for="remember-me">Remember Me</label> -->
    </div>
    <router-link to="/forget-password">Forgot Password?</router-link>
    </div>
            <b-button
              type="submit"
              class="btn primarycolor mt-2"
              style="border-radius: 32px !important"
            >
              <span
                v-if="loaderLogin"
                class="spinner-border spinner-border-sm mr-1"
                style="margin-bottom: 4px"
              ></span>
              <span>{{ translatedLang["Login"][selectedLanguage.key] }}</span>
            </b-button>
            <!-- <hr /> -->
            <h4 class="redirect mt-3">
              {{ translatedLang["New to Weavr?"][selectedLanguage.key]
              }}<span class="mx-3" @click="$router.push('/register')"
                >{{
                  translatedLang["Register here"][selectedLanguage.key]
                }}
                !</span
              >
              |
              <span class="mx-3"
                ><a
                  href="https://weavr.cloud/privacy-policy"
                  class="text-primary_brand"
                  target="_blank"
                  >{{
                    translatedLang["Privacy Policy"][selectedLanguage.key]
                  }}</a
                >
              </span>
            </h4>
          </b-form>
        </b-col>
      </b-row>
    </div>
    <!-- <div class="googleTranslatorCustom position-fixed">
            <div id="google_translate_element" class="translate-widget"></div>
        </div> -->
    <!-- <GoogleTranslateSelect
    default-language-code="en"
    default-page-language-code="en"
    :fetch-browser-language="false"
    trigger="click"
    @select="handleGoogleTranslateSelect" 
  /> -->
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import LanguageSelect from "../Components/LanguageSelect.vue";
import { mapState, mapActions } from "vuex";
export default {
  name: "Login",
  components: {
    Swiper,
    SwiperSlide,
    LanguageSelect,
  },
  data: function () {
    return {
      username: "",
      password: "",
      flagError: false,
      userAccess: {
        client: "",
      },
      loaderLogin: false,
      showPassword: false,
      slides: [
        {
          image: "Icons_SVG/LqsImgLogin.svg",
          title: "Magnify your eCommerce Presence with Weavr",
          description:
            "Analyse multilingual customer reviews to pinpoint key factors influencing ratings and drive product improvements",
        },
        // {
        //   image: "Icons_SVG/pincodeLoginLeftImg.svg",
        //   title: "Pin code-level Availability Tracking",
        //   description:
        //     "Check stock availability with pin code-level tracking, optimizing your location-based inventory systems",
        // },
        {
          image: "Icons_SVG/dataInsightsLoginImg.svg",
          title: "Unified Marketing Data Insights",
          description:
            "Integrate 50+ marketing channels in a single dashboard. Get in-depth campaign insights to supplement your marketing efforts and boost e-commerce business efficiency.",
        },
      ],
      currentSlide: 0,
      sliderImages: [
        {
          id: 1,
          altDec: "Meta icon",
          image: "Icons_SVG/metaLoginImgNew.svg",
        },
        {
          id: 2,
          altDec: "Google Analytics Icon",
          image: "Icons_SVG/GaLoginImgNew.svg",
        },
        {
          id: 3,
          altDec: "Twitter Icon",
          image: "Icons_SVG/twitterLoginImgNew.svg",
        },
        {
          id: 4,
          altDec: "Snapchat Icon",
          image: "Icons_SVG/snapchatLoginImg.svg",
        },
        {
          id: 5,
          altDec: "indiagate",
          image: "Icons_SVG/shopifyLoginImg.svg",
        },
      ],
      swiperOptions: {
        slidesPerView: 5,
        spaceBetween: 0,
        loop: true,
        autoplay: {
          delay: 0,
          disableOnInteraction: false,
        },
        speed: 900,
      },
    };
  },
  methods: {
    ...mapActions("DemoStore", [
      "setselectedLanguage",
      "initializeTranslation",
    ]),
    processRedirect(userAccess) {
      let items = [];
      if (userAccess.client === "amd") {
        items = [
          {
            name: "Summary",
            url: "/sov",
            icon: "icon-chart",
          },
          {
            name: "SOV Report",
            url: "/sov-report",
            icon: "icon-chart",
          },
        ];
      }
      if (userAccess.client === "amd_india_oem") {
        items = [
          {
            name: "Summary",
            url: "/sov-summary-amd",
            icon: "icon-chart",
          },
        ];
      }
      if (userAccess.client === "amd_india") {
        items = [
          {
            name: "Summary",
            url: "/sov-summary-amd",
            icon: "icon-chart",
          },
        ];
      }
      if (userAccess.is_demo) {
        delete localStorage.demo_voc_product_list;
        delete localStorage.demo_itemCategory;
        delete localStorage.demo_selectedItemCategory;
        if (userAccess.philips)
          items = [
            {
              name: "Summary",
              url: "/dashboard-sov",
              icon: "icon-chart",
            },
            {
              name: "Dashboard",
              url: "/dashboard-category-india",
              icon: "icon-speedometer",
            },
            {
              name: "Sentiment",
              url: "/sentiment-category-india",
              icon: "icon-chart",
            },
            {
              name: "Price",
              url: "/price-philips",
              icon: "icon-chart",
            },
          ];
        else
          items = [
            {
              name: "Summary",
              url: "/sov-dashboard",
              icon: "icon-chart",
            },
            {
              name: "Dashboard",
              url: "/dashboard-category",
              icon: "icon-speedometer",
            },
            {
              name: "Sentiment",
              url: "/sentiment-category",
              icon: "icon-chart",
            },
            // { name: "Price", url: "/price-hindware", icon: "icon-chart" },
          ];
      }

      if (userAccess.is_demo) {
        items = [
          {
            name: "Reviews and Ratings",
            icon: "icon-speedometer",
            submenuItems: [
              {
                name: "Summary",
                url: "/reviews/summary",
              },
              {
                name: "Brand Reviews",
                url: "/reviews/brand",
              },
              {
                name: "Category Reviews",
                url: "/reviews/category",
              },
              // {
              //     name: "Product Reviews",
              //     url: "/dashboard-category/" + userAccess.client,
              // },
              {
                name: "Product Reviews",
                url: "/reviews/product",
              },
            ],
          },
          // { name: "Price", url: "/price/" + userAccess.client, icon: "icon-chart" },
        ];
        if (userAccess.sov_lite) {
          items.unshift(
            {
              name: "Share of Search",
              url: "/share-of-search",
              icon: "icon-chart",
            },
            {
              name: "Share of Voice",
              url: "/sov-new",
              icon: "icon-chart",
            }
          );
        } else {
          items.unshift({
            name: "Share of Voice",
            url: "/sov/" + userAccess.client,
            icon: "icon-chart",
          });
        }
      }
      if (userAccess.is_global_demo) {
        items = [
          {
            name: "Share of Voice",
            url: "/global-sov/" + userAccess.client,
            icon: "icon-chart",
          },

          {
            name: "Market Explorer",
            url: "/global-price/" + userAccess.client,
            icon: "icon-chart",
          },
        ];
        if (userAccess.client === "global_demo") {
          items.push(
            {
              name: "Reviews and Ratings",
              url: "/global-dashboard-category/" + userAccess.client,
              icon: "icon-speedometer",
            },
            {
              name: "Sentiments",
              url: "/global-sentiments/" + userAccess.client,
              icon: "icon-chart",
            },
            {
              name: "Listing Analyser",
              url: "/lqs-analyser-global",
              icon: "icon-chart",
            }
          );
        }
      }

      if (userAccess.lqs) {
        items.push({
          name: "LQS Analyser",
          url: "/lqs-analyser",
          icon: "icon-chart",
        });
      }
      if (userAccess.is_rank) {
        items.push({
          name: "Best Sellers Ranking",
          url: "/keyword-tracker",
          icon: "icon-chart",
        });
      }

      if (userAccess.amd_india || userAccess.amd_india_oem) {
        items = [
          {
            name: "Summary",
            url: "/sov-summary-amd",
            icon: "icon-chart",
          },
        ];
      }

      if (userAccess.username == "admin") {
        items = [
          {
            name: "Admin Home",
            url: "/admin-dashboard",
            icon: "icon-chart",
          },
          {
            name: "Compliance New",
            url: "/admin-dashboard-new",
            icon: "icon-chart",
          },
          {
            name: "Compliance Automation",
            url: "/compliance-automation",
            icon: "icon-chart",
          },
          {
            name: "Spider Monitor",
            url: "/admin-monitoring",
            icon: "icon-chart",
          },
          {
            name: "Spider Management",
            url: "/admin-spiders-management",
            icon: "icon-chart",
          },
          {
            name: "SQL Sync",
            url: "/sql-sync",
            icon: "icon-chart",
          },
          {
            name: "Summary",
            url: "/sov",
            icon: "icon-chart",
          },
          {
            name: "SOV Report",
            url: "/sov-report",
            icon: "icon-chart",
          },
        ];
        // items = [
        // { name: 'Non AMD Spiders', url: '/admin-spiders-v2', icon: 'icon-chart' },
        // ]
      }
      if (userAccess.tools) {
        items = [
          {
            name: "LQS Analyser",
            url: "/lqs-analyser",
            icon: "icon-chart",
          },
          {
            name: "Best Sellers Ranking",
            url: "/keyword-tracker",
            icon: "icon-chart",
          },
        ];
      }

      if (!userAccess.is_demo && userAccess.sov_lite) {
        items.push(
          {
            name: "Share of Voice",
            url: "/sov-new",
            icon: "icon-chart",
          },
          {
            name: "Share of Search",
            url: "/share-of-search",
            icon: "icon-chart",
          }
        );
      }
      if (userAccess.is_price) {
        items.push({
          name: "Price",
          url: "/price/" + userAccess.client,
          icon: "icon-chart",
        });
      }
      if (userAccess.is_pincode) {
        items.push({
          name: "Availability Tracking",
          url: "/availability-matrix",
          icon: "icon-chart",
        });
      }
      if (userAccess.is_price_pin) {
        items.push({
          name: "Price Tracking",
          url: "/price-tracking",
          icon: "icon-chart",
        });
      }
      if (userAccess.buybox) {
        items.push({
          name: "Buybox Monitor",
          url: "/buy-box-monitor",
          icon: "icon-chart",
        });
      }
      if (userAccess.phrase_analyser) {
        items.push({
          name: "Phrase Analyser",
          url: "/phrase-analyser",
          icon: "icon-chart",
        });
      }
      if (userAccess.is_global_price) {
        items.push({
          name: "Market Explorer",
          url: "/global-price/" + userAccess.client,
          icon: "icon-chart",
        });
      }

      localStorage.vocSidebar = JSON.stringify(items);
      window.location = "#" + items[0].url;
    },
    plotNavBar() {
      let reviewUserData = JSON.parse(localStorage.reviewUserData);
      let client = reviewUserData.data.client;

      let navBarMapper = {
        summary: {
          name: "Summary",
          url: "/sov",
          icon: "icon-chart",
        },
        Share_Of_Voice: {
          name: "Share of Voice",

          url: "/sov-new",
          icon: "icon-chart",
        },
        Share_Of_Search: {
          name: "Share of Search",
          url: "/share-of-search",
          icon: "icon-chart",
          submenuItems: [
            {
              name: "Summary",
              url: "/share-of-search",
            },
            {
              name: "SOS",
              url: "/v-sos",
            },
          ]
        },
        Reviews_And_Ratings: {
          name: "Reviews and Ratings",
          icon: "icon-speedometer",
          url: "/reviews/brand",
          submenuItems: [
            {
              name: "Summary",
              url: "/reviews/summary",
            },
            {
              name: "Brand Reviews",
              url: "/reviews/brand",
            },
            {
              name: "Category Reviews",
              url: "/reviews/category",
            },
            {
              name: "Product Reviews",
              url: "/reviews/product",
            },
          ],
        },
        Sentiment: {
          name: "Sentiments",
          url: "/v-sentiments",
          icon: "icon-chart",
          
        },
        Your_Sentiments: {
          name: "Your Sentiments",
          url: "/sentiments-summary",
          icon: "icon-chart",
        },
        sov_report: {
          name: "SOV Report",
          url: "/sov-report",
          icon: "icon-chart",
        },
        admin_dashboard: {
          name: "Admin Home",
          url: "/admin-dashboard",
          icon: "icon-chart",
        },
        compliance_new: {
          name: "Compliance New",
          url: "/admin-dashboard-new",
          icon: "icon-chart",
        },
        compliance_automation: {
          name: "Compliance Automation",
          url: "/compliance-automation",
          icon: "icon-chart",
        },
        admin_monitoring: {
          name: "Spider Monitor",
          url: "/admin-monitoring",
          icon: "icon-chart",
        },
        admin_spider_management: {
          name: "Spider Management",
          url: "/admin-spiders-management",
          icon: "icon-chart",
        },
        sql_sync: {
          name: "SQL Sync",
          url: "/sql-sync",
          icon: "icon-chart",
        },
        Listing_Quality_Score: {
          name: "LQS Analyser",
          url: "/lqs-analyser",
          icon: "icon-chart",
        },
        Rank_Tracker: {
          name: "Best Sellers Ranking",
          url: "/keyword-tracker",
          icon: "icon-chart",
        },
        Price_Tracking: {
          name: "Price Tracking",
          url: "/price-tracking",
          icon: "icon-chart",
          submenuItems: [
            {
              name: "Summary",
              url: "/price-tracking",
            },
            {
              name: "Disparity",
              url: "/price-tracking-disparity",
            },
          ],
        },
        no_pin_price_tracking: {
          name: "Price",
          url: "/price/" + client.replaceAll(" ", "_"),
          icon: "icon-chart",
        },
        Availability_Tracking: {
          name: "Availability Tracking",
          url: "/availability-matrix",
          icon: "icon-chart",
        },
        Buy_Box_Monitor: {
          name: "Buybox Monitor",
          url: "/buy-box-monitor",
          icon: "icon-chart",
        },
        Phrase_Analyser: {
          name: "Phrase Analyser",
          url: "/phrase-analyser",
          icon: "icon-chart",
        },

        Market_Explorer: {
          name: "Market Explorer",
          url: "/global-price/" + client.replaceAll(" ", "_"),
          icon: "icon-chart",
        },

        Ads_Reporting: {
          name: "Ads Reporting",
          url: "/campaign-summary",
          icon: "icon-chart",
          submenuItems: [
            {
              name: "Campaign Summary",
              url: "/campaign-summary",
            },
            {
              name: "Custom Report",
              url: "/custom-report",
            },
            {
              name: "Connect Your Account",
              url: "/connect-your-account",
              icon: "icon-chart",
            }
          ],
        },
        Inventory_Analytics: {
          name: "Inventory Management",
          url: "/warehouse-summary",
          icon: "icon-chart",
          submenuItems: [
            {
              name: "Warehouse Summary",
              url: "/warehouse-summary",
            },
            {
              name: "Vendor Summary",
              url: "/vendor-summary",
            },
            {
              name: "FC Summary",
              url: "/fc-summary",
            },
          ],
        },
         Weavrwise: {
          name: "Weavrwise",
          url: "/weavrwise",
          icon: "icon-chart",
        },
        Report_Tab:{
          name: "Reports",
          url: "/reports-section",
          icon: "icon-chart",
        }
      };

      let items = [];

      if (!reviewUserData.userRegister) {
        items = [
          {
            name: "Form",
            url: "/demo-form",
            icon: "icon-chart",
          },
        ];
      } else {
        reviewUserData.data.nav_menu.forEach((nav) => {
          items.push(navBarMapper[nav]);
        });
        // items.push({
        //   name: "Connect Your Account",
        //   url: "/connect-your-account",
        //   icon: "icon-chart",
        // });
        if(reviewUserData.data.username=='Pegasus Account'){
          items = []
          items.push({
            name: "Inventory Management",
            url: "/summary",
            icon: "icon-chart",
            submenuItems: [
              {
                name: "Summary",
                url: "/summary",
              },
              {
                name: "Total Orders",
                url: "/total-orders",
              },
              {
                name: "Shiprocket Inbound Reco",
                url: "/grn-reco",
              },
              {
                name: "Stock Planning",
                url: "/stock-planing",
              },
              {
                name: "Daily Run Rate",
                url: "/drr-report",
              },
              {
                name: "Upload Files",
                url: "/upload-files",
              },
            ]
          })
        }
      }
      localStorage.vocSidebar = JSON.stringify(items);
      window.location = "#" + items[0].url;
    },
    login() {
      let url = "/api/sense_user/login";
      this.loaderLogin = true;
      if (!this.username) {
        this.flagError = true;
        this.loaderLogin = false;
        return false;
      }
      this.$http
        .post(url, {
          email_address: this.username,
          password: this.password,
          language: this.$store.state.DemoStore.selectedLanguage.key,
        })
        .then(
          (response) => {
            // if (response.body.data.nav_menu.includes("Share_Of_Voice")) {
            //     response.body.data.nav_menu.splice(1, 0, "Share_Of_Search")
            // }
            // if (response.body.data.client == "godrej") {
            //   response.body.data.nav_menu.push("Ads_Reporting");
            // }
            localStorage.setItem(
              "reviewUserData",
              JSON.stringify(response.body)
            );
            localStorage.setItem(
              "clientRegister",
              JSON.stringify(response.body.data.clientRegister)
            );
            localStorage.setItem(
              "coupon_applied",
              JSON.stringify(response.body.data.coupon_applied)
            );

            this.userAccess = response.body.data;
            if (!response.body.userRegister) {
              const storeNameAMD = ["amd", "amd_india_oem", "amd_india"];
              if (!storeNameAMD.includes(this.userAccess.client)) {
                this.plotNavBar();
              } else this.processRedirect(this.userAccess);
            } else {
              this.plotNavBar();
              this.processUserData(response.body);
            }
            this.loaderLogin = false;
          },
          (err) => {
            this.flagError = true;
            this.loaderLogin = false;
          }
        );
    },
    processUserData(userData) {
      let self = this;
      let nonPrimaryProductOptions = [];
      let primaryProductOptions = [];
      let forumProducts = [];
      for (let [idx, dataset] of userData.products.entries()) {
        if (dataset.primary) {
          primaryProductOptions.push(dataset);
        } else {
          nonPrimaryProductOptions.push(dataset);
        }
        if (dataset.forum) {
          forumProducts.push(dataset);
        }
      }
      let products = [];
      let selectedProducts = [];
      for (let [idx, dataset] of userData.products.entries()) {
        if (dataset.primary) {
          products.push(dataset);
          selectedProducts.push(dataset.product_name);
          break;
        }
      }
      for (let [idx, dataset] of userData.products.entries()) {
        if (products.length < 3) {
          if (!dataset.primary) {
            products.push(dataset);
            selectedProducts.push(dataset.product_name);
          }
        } else {
          break;
        }
      }

      let reviewCustomData = {
        primaryProductOptions: primaryProductOptions,
        nonPrimaryProductOptions: nonPrimaryProductOptions,
        products: products,
        selectedProducts: selectedProducts,
      };
      if (userData.data.show_forum) {
        reviewCustomData.forumProducts = forumProducts;
      }
      localStorage.setItem(
        "reviewCustomData",
        JSON.stringify(reviewCustomData)
      );
    },
    startSlideShow() {
      if (this.slideInterval) {
        clearInterval(this.slideInterval);
      }
      this.slideInterval = setInterval(() => {
        this.nextSlide();
      }, 3000);
    },
    nextSlide() {
      this.currentSlide = (this.currentSlide + 1) % this.slides.length;
    },
    goToSlide(index) {
      if (index === this.currentSlide) return;
      this.currentSlide = index;
      this.startSlideShow();
    },
  },
  computed: {
    ...mapState("DemoStore", ["selectedLanguage", "translatedLang"]),
  },
  mounted() {
    this.startSlideShow();
  },
  beforeUnmount() {
    if (this.slideInterval) {
      clearInterval(this.slideInterval);
    }
  },
};
</script>
<style scoped>
.loginPageContainer {
  background-color: #fff;
}

input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active {
  -webkit-box-shadow: 0 0 0 30px white inset !important;
  -webkit-text-fill-color: #000 !important;
  transition: background-color 5000s ease-in-out 0s;
}

button.password-toggle-btn {
  right: 3px;
  bottom: 8px;
  border: 0;
  background: #fff !important;
  padding: 6px;
  font-size: 15px;
  color: #a1a1a1 !important;
}

.inputIconContainer {
  margin: 14px 14px 14px 16px;
}

button.password-toggle-btn:focus {
  background: #fff !important;
}

.inputIconContainer img {
  width: 16px !important;
  height: 16px !important;
}

.slideImgContainer {
  padding-left: 15rem;
  padding-right: 15rem;
  padding-top: 4rem;
  padding-bottom: 40px !important;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.mainHeading {
  color: #000;
  font-family: "Poppins";
  font-weight: 600 !important;
  font-size: 28px;
  line-height: 36px;
  letter-spacing: 0%;
}

.subHeading {
  font-size: 16px;
  color: #050a13;
  font-weight: 400;
  font-family: "Poppins";
  margin-top: 16px !important;
}

.redirect {
  color: #050a13;
  font-family: Poppins;
  font-weight: 400;
  font-size: 16px;
}

.redirect span {
  color: var(--primary_brand) !important;
  cursor: pointer !important;
  font-family: Poppins;
  font-weight: 600;
  font-size: 16px;
}

.weavrLogoContainer {
  width: 70%;
  margin: 0 auto;
}

.app .weavr-logo img {
  height: 100%;
}

.container-fluid {
  height: 90vh !important;
  padding: 0 !important;
}

.hero-login-section {
  width: 100%;
  height: 100% !important;
}

input:-webkit-autofill {
  background-color: red !important;
}

.left-img,
.right-form {
  padding: 0 !important;
}

a {
  color: inherit;
}

a:hover {
  text-decoration: none;
  color: var(--primary_brand);
}

.login-form {
  width: 70%;
  margin: 0 auto;
}

.login-heading {
  margin-bottom: 24px !important;
}

.input-group {
  position: relative;
  margin-bottom: 1.3rem;
  flex-direction: column !important;
}

form.login-form label {
  font-size: 14px;
  font-weight: 400;
  font-family: "Poppins";
  color: #505050;
}

.input-group input {
  padding: 10px 12px 10px 40px;
  border: 1px solid #aeaeae;
  width: 100%;
  height: 100%;
  background: #fff !important;
  outline: none !important;
  border-radius: 5px;
  box-shadow: none !important;
}

.input-group input:focus {
  border: 1px solid var(--primary_brand) !important;
  outline: none !important;
  box-sizing: none !important;
}

.form-control::placeholder {
  color: #919191 !important;
  font-family: "poppins" !important;
  padding: 1.375rem 0.75rem !important;
  font-size: 0.9rem !important;
}

.danger {
  border-color: var(--red) !important;
  color: var(--red) !important;
}

.flagError {
  position: absolute;
  bottom: -30px;
}

.remember-forgot-section {
  display: flex;
  justify-content: space-between;
  color: var(--primary_brand);
  margin-top: 2rem;
}

.remember-forgot-section a {
  color: var(--primary_brand);
}

.remember-forgot-section label {
  margin-left: 0.5rem;
}

button.primarycolor {
  background: var(--primary_brand);
  font-family: "Poppins", sans-serif;
  color: white;
  padding: 12px 25px;
  border-radius: 10px;
  border: none;
  letter-spacing: 0.2px;
  font-weight: bold;
  font-size: 17px;
  width: 100%;
}

button.primarycolor:hover {
  color: white;
  background: var(--primary_brand-80);
}

button:focus {
  box-shadow: none !important;
  outline: none !important;
  background: var(--primary_brand);
}

.logoSection {
  padding: 20px 0px;
}

.login-page-slider {
  position: relative;
  width: 100%;
  height: 87vh;
  overflow: hidden;
}

.slider-container {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.slide-wrapper {
  position: absolute;
  width: 100%;
  height: 100%;
  opacity: 0;
  transform: translateX(-100%);
  transition: all 0.5s ease-in-out;
  visibility: hidden;
}

.slide-wrapper.active {
  opacity: 1;
  transform: translateX(0);
  visibility: visible;
}

.slide-wrapper:not(.active) {
  transform: translateX(100%);
  opacity: 0;
}

.slide-image {
  width: 100%;
  height: 100%;
}

.slide-content {
  position: absolute;
  top: 0%;
  left: 5%;
  max-width: 70%;
  padding: 2rem;
  z-index: 2;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
}

.slide-content h2 {
  color: var(--primary_brand);
  font-family: Poppins;
  font-weight: 600;
  font-size: 24px;
  line-height: 36px;
  text-shadow: none !important;
}

.slide-content p {
  font-family: Poppins;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0%;
  color: #000;
  text-shadow: none !important;
}

.slider-controls {
  position: absolute;
  bottom: 20px;
  width: 100%;
  display: flex;
  justify-content: center;
  z-index: 3;
}

.slider-dots {
  display: flex;
  gap: 10px;
}

.dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #c4c4c4;
  cursor: pointer;
  transition: all 0.3s ease;
}

.dot.active {
  background: var(--primary_brand);
  transform: scale(1.2);
}

.fullBgImg {
  background-color: #0655590d !important;
  background: url("../../../public/Icons_SVG/bgImgLogin.svg") no-repeat right
    center;
  height: 100vh;
  position: relative;
}
</style>
<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.app {
  font-family: "poppins";
}

:root {
  --weavr-color: #065559;
}

.app {
  height: 100vh;
  width: 100%;
}
</style>

<style scoped>
.brand-slider {
  width: 100%;
  padding: 1rem;
}

.brand-logo {
  width: 14rem;
  height: auto;
  object-fit: contain;
}

.brand-slide {
  display: flex;
  justify-content: center;
  align-items: center;
}

:deep(.swiper-container) {
  overflow: hidden;
}

input::placeholder {
  color: #a1a1a1 !important;
  font-size: 14px !important;
  font-family: "poppins" !important;
}
</style>
